/// <reference types="./updateCountEntitiesWithTypes.d.ts" />
import { ok } from '@dossierhq/core';
import { createSqliteSqlQuery } from '@dossierhq/database-adapter';
import { queryOne } from '../QueryFunctions.js';
export async function schemaUpdateCountEntitiesWithTypes(database, context, entityTypes) {
    const { sql, query, addValueList } = createSqliteSqlQuery();
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    sql `SELECT COUNT(*) AS count FROM entities WHERE uuid IS NOT NULL AND type IN ${addValueList(entityTypes)}`;
    const result = await queryOne(database, context, query);
    if (result.isError())
        return result;
    return ok(result.value.count);
}
//# sourceMappingURL=updateCountEntitiesWithTypes.js.map